import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { Toast } from 'vant'
import { sinopecapp_loadNative } from '@/utils/sinopecapp'

// 会员现金开票
// import CustInvoice from '@/views/Invoice/Cust/routes'
// 发票信息维护
// import InvoiceInfo from '@/views/Invoice/Info/routes'
// 发票对账单
// import InvoiceBill from '@/views/Invoice/Bill/routes'
// 备付金迁移查询
// import PreBalanceMove from '@/views/PreBalanceMove/routes'
// 扫码领券
// import Scan from '@/views/Scan/Coupon/routes'
// 办电子卡
// import Ecard from '@/views/Ecard/routes'
// 办单位实体卡
// import EntityCard from '@/views/EntityCard/routes'
// 实体卡限制信息(暂时保留 没做)
// import EntityLimit from '@/views/EntityLimit/routes'
// 白金卡
// import PlatinumCard from '@/views/PlatinumCard/routes'
// 资金池充值
// import CapitalPool from '@/views/CapitalPool/routes'
// 无卡支付授权
import NoCardAuth from '@/views/NoCardAuth/routes'
// 司机池
// import Driver from '@/views/Driver/routes'
// import InfoList from '@/views/Invoice/Info/routes'
// 会员现金开票
// import CustInvoice from '@/views/Invoice/Cust/routes'
// 电子票
// import Merge from '@/views/Invoice/PlainMerge/routes'
// 增票
// import Merge from '@/views/Invoice/AddMerge/routes'
// import MergeZp from '@/views/Invoice/AddMerge/routes'

// 定时开票
// import ScheInvoice from '@/views/ScheInvoice/routes'
// 意见反馈
// import Merge from '@/views/FeedBack/routes'
// 单位电子卡
// import Merge from '@/views/Ecard/routes'
// 实体卡办卡
// 电子卡管理
// import CardLimit from '@/views/CardLimit/routes'
// 实体卡副卡
// import ViceStk from '@/views/ViceStk/routes'
// 单位账户信息维护
// import userMain from '@/views/userMain/routes'
// 开通非油品授权
// import oilAuth from '@/views/oilAuth/routes'
// 撤单冲销
// import orderCancel from '@/views/OrderCancel/routes'
// 实体卡清户
// import clearAcce from '@/views/ClearAccountE/routes'
// 电子卡清户
// import clearAccD from '@/views/ClearAccountD/routes'
// 退款
// import returnMoney from '@/views/returnMoney/routes'
// 预约办卡
// import CreateCard from '@/views/CreateCard/routes'
// 增值票
// import Address from '@/views/Invoice/Address/routes'
// 入口文件
// import unifyEntry from '@/views/unifyEntry/routes'
// 共享账户支付
// import SharePayment from '@/views/SharePayment/routes'
Vue.use(VueRouter)

let routes = [
  // SharePayment,
  // InvoiceBill,
  // CapitalPool,
  // CardLimit,
  // ViceStk,
  // Driver,
  // ...InfoList,
  // CustInvoice,
  // userMain,
  // oilAuth,
  // Ecard,
  // Merge,
  // MergeZp,
  // ScheInvoice,
  // EntityCard,
  NoCardAuth,
  // orderCancel,
  // NoCardAuth,
  // orderCancel,
  // ...Address,
  // NoCardAuth,
  // orderCancel,
  // returnMoney,
  // unifyEntry,
  // Merge,
  // clearAcce,
  // clearAccD,
  // CreateCard,
  {
    path: '/401',
    name: '401',
    meta: { title: '操作超时' },
    component: () => import('@/views/Error/401')
  },
  {
    path: '/402',
    name: '402',
    meta: { title: '操作超时' },
    component: () => import('@/views/Error/402')
  },
  {
    path: '/403',
    name: '403',
    meta: { title: '未绑卡' },
    component: () => import('@/views/Error/403')
  },
  {
    path: '*',
    name: '404',
    meta: { title: '404' },
    component: () => import('@/views/Error/404')
  }
]

// Vue.use(VueRouter)
// let routes = [
//   // 兔年限定卡
//   CapitalPool,
//   {
//     path: '/401',
//     name: '401',
//     meta: { title: '操作超时' },
//     component: () => import('@/views/Error/401')
//   },
//   {
//     path: '/402',
//     name: '402',
//     meta: { title: '操作超时' },
//     component: () => import('@/views/Error/402')
//   },
//   {
//     path: '/403',
//     name: '403',
//     meta: { title: '未绑卡' },
//     component: () => import('@/views/Error/403')
//   },
//   {
//     path: '*',
//     name: '404',
//     meta: { title: '404' },
//     component: () => import('@/views/Error/404')
//   }
// ]
// let address = Address
// routes = routes.concat(address)
// let InfoLists = InfoList
// routes = routes.concat(InfoLists)
// let address = Address
// routes = routes.concat(address)
// let InfoLists = InfoList
// routes = routes.concat(InfoLists)
// let address = Address
// routes = routes.concat(address)
// let InfoLists = InfoList
// routes = routes.concat(InfoLists)
const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? process.env.BASE_URL : '/appweb/',
  routes
})

const whiteList = ['/403', '/402', '/401']

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title

  const { userAccount, cardNoList } = store.state.user

  const showNav = !!to.meta.show
  sinopecapp_loadNative('showTitleBar', '{"show":' + showNav + '}')

  if (whiteList.indexOf(to.path) != -1) {
    next()
  } else if (userAccount) {
    if (to.meta.noCard || (cardNoList && cardNoList.length)) {
      next()
    } else {
      router.push('/403')
    }
  } else {
    try {
      // 检查用户是否是车管家
      // const query = to.query
      // console.log(query)
      // if (query.AppModuleName && query.AppModuleName == 'cgj') {
      //   sessionStorage.setItem('AppModuleName', 'cgj')
      // } else {
      //   sessionStorage.setItem('AppModuleName', '')
      // }
      await store
        .dispatch('user/getInfo')
        .then(response => {
          const user = response
          if (to.meta.noCard || (user.cardNoList && user.cardNoList.length)) {
            next()
          } else {
            router.push(user.userType == 1 ? '402' : '/403')
          }
        })
        .catch(() => router.push('/401'))
    } catch (error) {
      Toast('获取用户信息失败')
    }
  }
})

export default router
